import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddCurrencyMutation,
  useDeleteCurrencyMutation,
  useEditCurrencyMutation,
  useGetCurrenciesQuery,
} from "../../../../../redux/Service/currenciesApi";

function Currencies() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const {
    data: currenciesData,
    isLoading: isCurrenciesLoading,
    isError: isCurrenciesError,
  } = useGetCurrenciesQuery(undefined);

  const currencies = currenciesData?.ResponseObject ?? [];

  const [deleteCurrency, { isLoading: isDeleting }] =
    useDeleteCurrencyMutation();
  const [addCurrency, { isLoading: isAdding }] = useAddCurrencyMutation();
  const [updateCurrency, { isLoading: isUpdating }] = useEditCurrencyMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف العملة "${record.CurrID}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteCurrency(record.CurrID).unwrap();

          if (response?.ResponseObject == true) {
            message.success("تم حذف العملة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "اسم العملة",
      dataIndex: "CurrName",
      key: "CurrName",
    },
    {
      title: "الفئة",
      dataIndex: "CurrPart",
      key: "CurrPart",
    },
    {
      title: "سعر الصرف",
      dataIndex: "CurrRate",
      key: "CurrRate",
    },
    {
      title: "افتراضي؟",
      dataIndex: "IsDefualte",
      key: "IsDefualte",
      render: (value) => (value ? "نعم" : "لا"),
    },
  ];

  const handleOk = async (values) => {
    try {
      let response;
      if (isEditing) {
        response = await updateCurrency(values).unwrap();
      } else {
        response = await addCurrency(values).unwrap();
      }

      if (response?.ResponseObject == true) {
        message.success(
          isEditing ? "تم تعديل العملة بنجاح" : "تمت إضافة العملة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={currencies}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isCurrenciesLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Currencies;
